import { gql } from '@apollo/client'

// Nested lists are UNSORTED by default — the explicit `orderBy: { arrangement: asc }`
// on both `footer_columns` and `footer_links` is required, order is otherwise arbitrary.
export const GET_FOOTER_SETTINGS = gql`
  query GET_FOOTER_SETTINGS {
    findFirstShopSetting {
      id
      footer_address
      footer_phone
      footer_email
      footer_copyright_text
      facebook
      twitter
      instagram
      pinterest
      linkedin
      footer_columns(orderBy: { arrangement: asc }) {
        id
        arrangement
        footer_column_profiles {
          language
          heading
        }
        footer_links(orderBy: { arrangement: asc }) {
          id
          arrangement
          link_type
          link_page_id
          link_category_id
          link_collection_id
          external_url
          link_new_tab
          footer_link_profiles {
            language
            label
          }
        }
      }
    }
  }
`

// `updateFooterSettings` returns `ShopSetting!` (non-null). Selects only
// `{ id }` so this response can't normalize an UNSORTED `footer_columns`/
// `footer_links` list over the query's `orderBy`-sorted cache entries;
// `refetchQueries` re-runs the real (sorted) query above instead.
export const UPDATE_FOOTER_SETTINGS = gql`
  mutation UPDATE_FOOTER_SETTINGS(
    $columns: [FooterColumnInput!]!
    $facebook: String
    $twitter: String
    $instagram: String
    $pinterest: String
    $linkedin: String
    $footer_address: String
    $footer_phone: String
    $footer_email: String
    $footer_copyright_text: String
  ) {
    updateFooterSettings(
      columns: $columns
      facebook: $facebook
      twitter: $twitter
      instagram: $instagram
      pinterest: $pinterest
      linkedin: $linkedin
      footer_address: $footer_address
      footer_phone: $footer_phone
      footer_email: $footer_email
      footer_copyright_text: $footer_copyright_text
    ) {
      id
    }
  }
`
